import TABLE_DATA_KEYS from "@/components/base_components/tables/enum/table-data-keys";

const decodeFiltersOfQueryString = (queryArray) => {
    const filters = {};

    for (const filterString of queryArray) {
        const indexOfEquals = filterString.indexOf('=');
        const key = filterString.substring(0, indexOfEquals);
        let value = (filterString.substring(indexOfEquals + 1, filterString.length));
        filters[key] = castValue(value);
    }
    return filters;
}

const decodeFilterOrderOfQueryString = (queryArray) => {
    const filterOrderIndex = getIndexOfKeyValuePairForTableKey(queryArray, TABLE_DATA_KEYS.FILTER_ORDER);
    const filterOrderValue = getValueOfQueryKeyValuePair(getKeyValueQueryPairForIndex(queryArray, filterOrderIndex));
    deleteIndexOfQueryArray(queryArray, filterOrderIndex);
    return decodeStringToArray(filterOrderValue);
}

const decodeNotVisibleFiltersQueryString = (queryArray) => {
    const notVisibleFiltersIndex = getIndexOfKeyValuePairForTableKey(queryArray, TABLE_DATA_KEYS.NOT_VISIBLE_FILTERS);
    const notVisibleFiltersValue = getValueOfQueryKeyValuePair(getKeyValueQueryPairForIndex(queryArray, notVisibleFiltersIndex));
    deleteIndexOfQueryArray(queryArray, notVisibleFiltersIndex);
    return decodeStringToArray(notVisibleFiltersValue);
}

const decodeTruncateOfQueryString = (queryArray) => {
    const truncateDataIndex = getIndexOfKeyValuePairForTableKey(queryArray, TABLE_DATA_KEYS.TRUNCATE_DATA);
    const truncateData = castValue(getValueOfQueryKeyValuePair(getKeyValueQueryPairForIndex(queryArray, truncateDataIndex)));

    deleteIndexOfQueryArray(queryArray, truncateDataIndex);
    if (truncateData === false) { return { [TABLE_DATA_KEYS.TRUNCATE_DATA]: truncateData } }

    const truncateOptionsIndex = getIndexOfKeyValuePairForTableKey(queryArray, TABLE_DATA_KEYS.TRUNCATE_OPTIONS);
    let truncateOptionValue = getValueOfQueryKeyValuePair(getKeyValueQueryPairForIndex(queryArray, truncateOptionsIndex));
    const truncateOptions = truncateOptionValue == 'undefined' ? {} : JSON.parse(getValueOfQueryKeyValuePair(getKeyValueQueryPairForIndex(queryArray, truncateOptionsIndex)));
    deleteIndexOfQueryArray(queryArray, truncateOptionsIndex);

    return {
        [TABLE_DATA_KEYS.TRUNCATE_DATA]: truncateData,
        [TABLE_DATA_KEYS.TRUNCATE_OPTIONS]: truncateOptions
    }
}

const getValueOfQueryKeyValuePair = (queryKeyValuePair) => {
    return queryKeyValuePair.substring(queryKeyValuePair.indexOf('=') + 1, queryKeyValuePair.length)
}

const getIndexOfKeyValuePairForTableKey = (queryArray, tableKey) => {
    return queryArray.findIndex((_string) => _string.includes(`${tableKey}=`));
}

const getKeyValueQueryPairForIndex = (queryArray, index) => {
    return queryArray[index];
}

const deleteIndexOfQueryArray = (queryArray, index) => {
    queryArray.splice(index, 1);
}

const decodeStringToArray = (string) => {
    return string.length > 0 ? string.split(',').map(item => castValue(item)) : [];
}

const castValue = (value) => {
    const isWrappedArray = value.charAt(0) === '[' && value.charAt(value.length - 1) === ']';
    if (isWrappedArray) {
        const contentOfArray = value.replace('[', '').replace(']', '');
        return decodeStringToArray(contentOfArray);
    }

    const isBoolean = value === 'true' || value === 'false';
    if (isBoolean) {
        return value === 'true';
    }

    return value;
}

export default {
    generateFilterObjectsOutOfQueryString(filterQuery) {
        let queryArray = filterQuery.split('&');
        const filterObject = {};

        const { truncateData, truncateOptions } = decodeTruncateOfQueryString(queryArray);
        filterObject[TABLE_DATA_KEYS.TRUNCATE_DATA] = truncateData;
        filterObject[TABLE_DATA_KEYS.TRUNCATE_OPTIONS] = truncateOptions;

        filterObject[TABLE_DATA_KEYS.FILTER_ORDER] = decodeFilterOrderOfQueryString(queryArray);
        filterObject[TABLE_DATA_KEYS.NOT_VISIBLE_FILTERS] = decodeNotVisibleFiltersQueryString(queryArray);
        filterObject[TABLE_DATA_KEYS.FILTERS] = decodeFiltersOfQueryString(queryArray);

        return filterObject;
    },

    generateColumnObjectsOutOfQueryString(query) {

        const queryArray = query.split('&');
        const columnObject = {};

        for (const queryPart of queryArray) {
            const indexOfEquals = queryPart.indexOf('=');
            const key = queryPart.substring(0, indexOfEquals);
            let value = (queryPart.substring(indexOfEquals + 1, queryPart.length));

            columnObject[key] = decodeStringToArray(value);
        }

        return columnObject;
    },
}
